// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ooHND{display:flex;flex-direction:column;gap:24px}.LcASQ{display:flex;align-items:center;justify-content:space-between}.BdYTD{width:140px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cards": `ooHND`,
	"cardContent": `LcASQ`,
	"actionButton": `BdYTD`
};
export default ___CSS_LOADER_EXPORT___;
